import { render, staticRenderFns } from "./IconScheduleCopy.vue?vue&type=template&id=5e8d25ff"
import script from "./IconScheduleCopy.vue?vue&type=script&lang=ts"
export * from "./IconScheduleCopy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports